import './RichText.scss';

import { type BlocksData, serializeLexical } from './serialize-lexical';

const className = 'c-RichText';

type RichTextProps = {
  content: unknown;
  data?: BlocksData;
};

export const RichText = ({ content, data }: RichTextProps) => {
  return <div className={className}>{serializeLexical({ content, data })}</div>;
};
